import { docReady } from '../utilities';

//Control to make placeholder switch to a label when user starts typing
docReady(function() {
    // DOM is loaded and ready for manipulation here
    var inputs = document.querySelectorAll('input, textarea, select');
    var i;

    for (i = 0; i < inputs.length; i++) {
        if (inputs[i].type === 'select-one') {
            inputs[i].addEventListener('change', function(e) {
                if (e.target.value === '') {
                    e.target.closest('.field')
                        ? e.target
                              .closest('.field')
                              .classList.remove('field--show-floating-label')
                        : '';
                } else {
                    e.target.closest('.field')
                        ? e.target
                              .closest('.field')
                              .classList.add('field--show-floating-label')
                        : '';
                }
            });
        } else {
            if (
                inputs[i].parentElement.parentElement.classList.contains(
                    'field--with-floating-label'
                )
            ) {
                inputs[i].addEventListener('keyup', function(e) {
                    if (e.target.value === '') {
                        e.target
                            .closest('.field')
                            .classList.remove('field--show-floating-label');
                    } else {
                        e.target
                            .closest('.field')
                            .classList.add('field--show-floating-label');
                    }
                });
            }
        }
    }
});
